export const getLinkedDataBlockKey = (mentionId: string) => {
  let dataId;
  if (mentionId.indexOf('.') !== -1) {
    const mentionsArray = mentionId.split('.');
    dataId = mentionsArray[ mentionsArray.length - 1 ];
  } else {
    dataId = mentionId;
  }
  return dataId[ 0 ].toLowerCase() + dataId.slice(1);
};